export default __webpack_public_path__ + "static/media/C20AF707-E2B6-494F-8797-9D31BD76310B.d9568a49.jpeg";